<template>
    <div>
        <b-form-group class="questions">
            <!-- <label class="h3">
                Questions
            </label> -->

            <div v-for="(question, index) in form" :key="index">
                <b-input-group>
                    <b-form-input
                        class="tb-form-field tb-form-field--with-side-by-side"
                        type="text"
                        v-model="form[index].text"
                        disabled>    
                    </b-form-input>

                    <b-input-group-append>
                        <b-button
                            class="tb-form-field__side-by-side tb-form-field__side-by-side--danger"
                            @click.prevent="removeQuestion(question.id)">
                            Remove
                        </b-button>
                    </b-input-group-append>
<!--
                            variant="danger"-->
                </b-input-group>
            </div>
            
            <b-input-group>
                <b-form-input
                    class="tb-form-field tb-form-field--with-side-by-side add-a-question"
                    type="text"
                    v-model="new_question.text"
                    placeholder="Add a question">    
                </b-form-input>

                <b-input-group-append>
                    <b-button
                        class="tb-form-field__append tb-form-field__side-by-side"
                        variant="primary"
                        @click.prevent="addQuestion"
                        :disabled="new_question.text.length == 0">
                        Add
                    </b-button>
                </b-input-group-append>
            </b-input-group>
        </b-form-group>
    </div>
</template>

<script>
    import questionRepository from "@/repository/questions";

    export default {
        props: {
            questions: {
                default: () => []
            },

            eventId: {
                required: true
            }
        },

        data() {
            return {
                form: [],
                new_question: {
                    text: "",
                    event_id: this.eventId
                }
            }
        },

        mounted() {
            this.form = [
                ...this.questions
            ];
        },

        methods: {
            addQuestion() {
                questionRepository.store(this.new_question)
                    .then(response => {
                        let new_question = response.data;
                        this.form.push(new_question);
                        this.new_question.text = "";

                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Question added',
                            text: 'New question successfully added.'
                        });
                    });

                this.$emit('changed', { ...this.form });
            },

            removeQuestion(id) {
                questionRepository.destroy(id)
                    .then(response => {
                        let idx = this.form.findIndex(q => q.id === response.data.id);
                        this.$delete(this.form, idx);

                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Question removed',
                            text: 'Question successfully removed'
                        });
                    });

                this.$emit('changed', { ...this.form });
            }
        }
    }
</script>

<style scoped lang="scss">
    .questions {
        .input-group {
            margin-bottom: 10px;
        }

        input {
            margin-bottom: 0!important;
        }

        .add-a-question::placeholder {
            text-align: left;
        }
    }
</style>